import type { JSX } from 'react'
import type { IButtonProps } from '../Button'

import { IconNames } from 'atoms/Icon/Icon.h'
import { COLOR } from 'vars/color'
import { Button } from '../Button'
import {
  ButtonBordersWidth,
  ButtonColors,
  ButtonCorners,
  ButtonFluid,
  ButtonFonts,
  ButtonIconSizes,
  IconPositions,
} from '../Button.h'

export interface IInlineForwardArrowWithTitleProps extends IButtonProps {}

export const InlineForwardArrowWithTitle = ({
  title = 'See all',
  icon = IconNames.angleRight,
  iconPosition = IconPositions.Right,
  iconSize = ButtonIconSizes.medium,
  corners = ButtonCorners.CORNERS_10,
  colorDefault = ButtonColors.COLOR_PRIMARY,
  colorHovered = ButtonColors.SURFACE_LIGHT_2,
  colorPressed = ButtonColors.COLOR_MAIN_PRESSED,
  colorDisabled = ButtonColors.COLOR_DISABLED,
  backgroundColorDefault = COLOR.TRANSPARENT,
  backgroundColorDisabled = COLOR.TRANSPARENT,
  borderWidth = ButtonBordersWidth.BORDER_0,
  font = ButtonFonts.Button1,
  fluid = ButtonFluid.None,
  ...rest
}: IInlineForwardArrowWithTitleProps): JSX.Element => {
  return (
    <Button
      title={title}
      icon={icon}
      iconPosition={iconPosition}
      iconSize={iconSize}
      corners={corners}
      colorDefault={colorDefault}
      colorHovered={colorHovered}
      colorPressed={colorPressed}
      colorDisabled={colorDisabled}
      backgroundColorDefault={backgroundColorDefault}
      backgroundColorDisabled={backgroundColorDisabled}
      borderWidth={borderWidth}
      font={font}
      fluid={fluid}
      {...rest}
    />
  )
}

InlineForwardArrowWithTitle.displayName = 'InlineForwardArrowWithTitle'
